import { buttonColors, chartingColorOffsets, chartingColors, colors, commonColors, gradients, iconColors, inputColors, statusColors, typeColors, } from '@workday/canvas-colors-web';
import { borderRadius } from './lib/radius';
import { BrandingColor } from './lib/colors.types';
import { depth } from './lib/depth';
import { space, spaceNumbers, } from './lib/space';
import { type, fontFamily, monoFontFamily, } from './lib/type';
export const canvas = {
    buttonColors,
    chartingColorOffsets,
    chartingColors,
    colors,
    commonColors,
    depth,
    fontFamily,
    gradients,
    iconColors,
    inputColors,
    monoFontFamily,
    space,
    statusColors,
    type,
    typeColors,
};
export * from '@workday/canvas-colors-web';
export { borderRadius, colors, gradients, depth, space, spaceNumbers, type, fontFamily, monoFontFamily, BrandingColor, };
